import { useLang } from "../../context/LanguageContext";
import { useContent } from "../../context/ContentContext";
import { RULES } from "../../data/content";
import { BUSINESS } from "../../lib/api";
import { Reveal, SectionHeading } from "../Reveal";
import { Icon } from "../Icon";

export const Pricing = () => {
  const { t, lang } = useLang();
  const { content } = useContent();
  const rate = content.pricing?.nightlyRate ?? BUSINESS.nightlyRate;
  const cleaning = content.pricing?.cleaningFee ?? BUSINESS.cleaningFee;
  const ruleText = (key) => {
    if (key === "checkin" && content.checkin?.[lang]) return content.checkin[lang];
    if (key === "checkout" && content.checkout?.[lang]) return content.checkout[lang];
    return t(`pricing.rules.${key}`);
  };
  return (
    <section id="pricing" className="scroll-mt-20 bg-[#1C1917] px-4 sm:px-8 py-20 lg:py-28 text-stone-100">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#D9A05B]">{t("pricing.eyebrow")}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-serif tracking-tight text-white">{t("pricing.title")}</h2>
        </Reveal>

        <div className="mt-10 grid gap-6 lg:grid-cols-5">
          <Reveal className="lg:col-span-2">
            <div className="flex h-full flex-col justify-between rounded-3xl bg-gradient-to-br from-[#C85A32] to-[#B04B26] p-8">
              <div>
                <p className="text-sm font-medium uppercase tracking-wide text-white/80">{t("pricing.from")}</p>
                <p className="mt-2 font-serif text-6xl font-semibold text-white">€{rate}</p>
                <p className="text-white/85">{t("pricing.perNight")}</p>
              </div>
              <div className="mt-8 space-y-2 border-t border-white/20 pt-6 text-sm text-white/90">
                <div className="flex justify-between"><span>{t("pricing.cleaning")}</span><span className="font-semibold">€{cleaning}</span></div>
                <div className="flex justify-between"><span>{t("pricing.tax")}</span><span className="font-semibold">{t("pricing.taxNote")}</span></div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-3">
            <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-8">
              <h3 className="font-serif text-2xl text-white">{t("pricing.rulesTitle")}</h3>
              <div className="mt-6 grid gap-3 sm:grid-cols-2">
                {RULES.map((r) => (
                  <div key={r.key} data-testid={`rule-${r.key}`} className="flex items-center gap-3 rounded-xl bg-white/[0.04] p-3.5">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#D9A05B]/15 text-[#D9A05B]">
                      <Icon name={r.icon} className="h-4.5 w-4.5" />
                    </span>
                    <span className="text-sm text-stone-200">{ruleText(r.key)}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
